document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('a[href="/cart"]').forEach((link) => {
        link.addEventListener("click", function (event) {
            event.preventDefault();
            openMinicart();
        });
    });

    if (window.location.pathname === "/cart") {
        window.location.href = "/?open_cart=1";
        openMinicart();
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("open_cart") === "1") {
        openMinicart();
    }
});
